import React, {useState, useEffect} from 'react';
import {Modal, Text, TextInput, Button} from '@/ui-kits';

interface ManagePopularityLimitModalProps {
  open: boolean;
  onClose: () => void;
  onSave: (data: {limit: number}) => void;
  currentLimit?: number;
}

export const ManagePopularityLimitModal: React.FC<ManagePopularityLimitModalProps> = ({
  open,
  onClose,
  onSave,
  currentLimit,
}) => {
  const [limit, setLimit] = useState<string>('');

  useEffect(() => {
    if (open) {
      // Set current limit when modal opens if it's provided
      if (currentLimit !== undefined && currentLimit !== null && currentLimit > 0) {
        setLimit(currentLimit.toString());
      } else {
        setLimit('');
      }
    }
  }, [open, currentLimit]);

  const handleSave = () => {
    const limitValue = parseInt(limit, 10);
    if (isNaN(limitValue) || limitValue < 0) return;
    
    onSave({
      limit: limitValue,
    });
    
    onClose();
  };

  const handleLimitChange = (value: string) => {
    // Only allow numeric input
    const numericValue = value.replace(/[^0-9]/g, '');
    setLimit(numericValue);
  };

  const limitValue = parseInt(limit, 10);
  const isFormValid = !isNaN(limitValue) && limitValue >= 0 && limit.trim().length > 0;

  return (
    <Modal
      open={open}
      onClose={onClose}
      className="relative bg-white py-6 px-8 rounded-xl gap-4 w-[90vw] max-w-[500px]">
      <Text variant="free" className="text-ui_blue font-FigtreeBold text-2xl mb-4">
        Popular Display Settings
      </Text>

      <div className="flex flex-col gap-4">
        {/* Category-wise Limit */}
        <TextInput
          label="Category-wise Limit"
          value={limit}
          onChangeText={handleLimitChange}
          placeholder="Enter limit"
          className="w-full"
          wrapperClassName="!border-ui_placeholder"
          required
          type="numeric"
        />
      </div>

      {/* Action Buttons */}
      <div className="flex gap-4 mt-6">
        <Button
          variant="secondary"
          title="Cancel"
          onClick={onClose}
          className="flex-1"
        />
        <Button
          variant="primary"
          title="Save"
          onClick={handleSave}
          disabled={!isFormValid}
          className="flex-1"
        />
      </div>
    </Modal>
  );
};

